// extracted by mini-css-extract-plugin
module.exports = {"ChartWrapper":"DeliveryHistoryLineChart_ChartWrapper__gIHvD"};